import { render, staticRenderFns } from "./RatioApertura.vue?vue&type=template&id=a4ddc222"
import script from "./RatioApertura.vue?vue&type=script&lang=js"
export * from "./RatioApertura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports